import { useState } from 'react';

import { Tabs } from '@/core/components/Tabs/Tabs';
import { TabsVariant } from '@/core/components/Tabs/Tabs.types';

import { SectionContent, SectionsContainer } from './ReportSections.styles';
import { ReportSectionId, ReportSectionTab, ReportSectionsBaseProps } from './ReportSections.types';
import { DetailsSection } from './DetailsSection';
import { ArticlesSection } from './ArticlesSection';
import { MediaSection } from './MediaSection';
import { useReportSourcesRefresh } from './useReportSourcesRefresh';

const TABS: Array<ReportSectionTab> = [
  {
    id: ReportSectionId.DETAILS,
    name: 'Details',
  },
  {
    id: ReportSectionId.ARTICLES,
    name: 'Articles',
  },
  {
    id: ReportSectionId.MEDIA,
    name: 'Media',
  },
];

export const ReportSections = ({
  report,
  country,
  categories,
  locationAddress,
  eventDate,
  eventLocalTime,
}: ReportSectionsBaseProps) => {
  const [activeTab, setActiveTab] = useState<ReportSectionId>(ReportSectionId.DETAILS);
  const { refreshStatus, refreshUpdatedAt, articlesCountDelta, mediaCountDelta, refreshSources } =
    useReportSourcesRefresh(report);

  const activeSection = (() => {
    switch (activeTab) {
      case ReportSectionId.DETAILS:
        return (
          <DetailsSection
            report={report}
            country={country}
            locationAddress={locationAddress}
            eventDate={eventDate}
            eventLocalTime={eventLocalTime}
            categories={categories}
          />
        );
      case ReportSectionId.ARTICLES:
        return (
          <ArticlesSection
            sources={report.source}
            refreshStatus={refreshStatus}
            refreshUpdatedAt={refreshUpdatedAt}
            countDelta={articlesCountDelta}
            onRefresh={refreshSources}
          />
        );
      case ReportSectionId.MEDIA:
        return (
          <MediaSection
            sources={report.source}
            refreshStatus={refreshStatus}
            refreshUpdatedAt={refreshUpdatedAt}
            countDelta={mediaCountDelta}
            onRefresh={refreshSources}
          />
        );
    }
  })();

  return (
    <SectionsContainer>
      <Tabs<ReportSectionId>
        tabs={TABS}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        variant={TabsVariant.SECONDARY}
      />
      <SectionContent $variant={activeTab}>{activeSection}</SectionContent>
    </SectionsContainer>
  );
};
